import { getCollectionUrl } from '../utils';
import json from './json.js';

export const FETCH_PAGE = 'FETCH_PAGE';
export const PARSE_PAGE = 'PARSE_PAGE';

const initialState = [];

export function parsePage(json) {
  const pages = json.entries !== undefined ? json.entries : null;
  return { type: PARSE_PAGE, pages: pages };
}

export function fetchCollection(collection) {
  return dispatch => {
    const data = { entries: json };
    dispatch(parsePage(data));
  };
}

export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case FETCH_PAGE:
      return action;

    case PARSE_PAGE:
      newState = action.pages;
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/pages.js